
///<reference path="./ScrollObjectBase.ts"/>

namespace khi.bk117.view.parts.scroll
{
	import EventDispatcher = com.enirva.event.EventDispatcher;
	import Sprite = com.enirva.display.Sprite;
	import Tween = com.enirva.tween.Tween;
	import ScrollObjectBase = khi.bk117.view.parts.scroll.ScrollObjectBase;

	/*
	 * 背景を切り替えるオブジェクト　
	 */
	export class BackgroundTrigger extends ScrollObjectBase
	{
		public colorType:string;


		constructor(target:JQuery)
		{
			super(target);

			var cls:string[] = target.attr("class").split(" ");

			for (var i:number = 0; i < cls.length; i++)
			{
				if (cls[i].indexOf("BGCOLOR_") >= 0)
				{
					this.colorType = cls[i].replace("BGCOLOR_", "");
					break;
				}
			}
		}


		public update(curr:number, winH:number, isForce:boolean = false):void
		{
			if (!this.isShow)
			{
				
			}
		}


		public updateOffset():void
		{
			this.offsetY = this.spt.element.offset().top;
		}
	}
}

